<template>
  <div class="my-card">
    <b-overlay
      :show="loading"
      rounded="sm"
    >
      <b-card
        v-bind="cardAttrs"
        no-body
        v-on="$listeners"
      >
        <div class="card-header">
          <!-- Title & SubTitle -->
          <div>
            <b-card-title>
              <div class="my-card-header__left">
                <span class="mr-1">{{ $attrs.title }}</span>
                <slot name="headerLeft" />
              </div>
            </b-card-title>
            <b-card-sub-title v-if="$attrs['sub-title']">
              {{ $attrs['sub-title'] }}
            </b-card-sub-title>
          </div>
          <!-- Right btn -->
          <div v-if="collapseSwitch">
            <slot name="btns" />
            <feather-icon
              class="text-primary ml-1"
              style="cursor: pointer;"
              :icon="`${body_visible?'Minimize2Icon':'Maximize2Icon'}`"
              size="22"
              @click="handleCollapseChange"
            />
          </div>
        </div>
        <div
          v-if="$scopedSlots.base"
          class="pl-2 pr-2"
          style="transition: all .3s;"
          :class="{'pb-2' : !body_visible}"
        >
          <slot name="base" />
        </div>
        <b-card-body>

          <!-- Card Content -->
          <b-collapse
            v-model="body_visible"
            class="card-code"
            :visible="body_visible"
          >
            <div class="p-2">
              <slot />
            </div>
          </b-collapse>
        </b-card-body>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BCard, BCardTitle, BCardSubTitle, BCardBody, BCollapse, BOverlay,
} from 'bootstrap-vue'
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
import Prism from 'vue-prism-component'

export default {
  name: 'BCardBtn',
  components: {
    BCard,
    BCardTitle,
    BCardSubTitle,
    BCardBody,
    BCollapse,
    BOverlay,
  },
  inheritAttrs: false,
  props: {
    bodyVisible: {
      type: Boolean,
      default: false,
    },
    collapseSwitch: {
      type: Boolean,
      default: true,
    },
    row: {
      type: Object,
      default: () => {},
    },
    // 打开前的回调
    beforeOpen: {
      type: Function,
      default: done => { done() },
    },
  },
  data() {
    return {
      body_visible: this.bodyVisible,
      loading: false,
    }
  },
  computed: {
    cardAttrs() {
      const cardAttrs = JSON.parse(JSON.stringify(this.$attrs))
      delete cardAttrs.title
      delete cardAttrs['sub-title']
      return cardAttrs
    },
  },
  methods: {
    handleCollapseChange() {
      let isDone = false
      const done = () => {
        if (!isDone) {
          this.body_visible = !this.body_visible
          isDone = true
          this.loading = false
        }
      }
      if (!this.body_visible) {
        this.loading = true
        this.beforeOpen(done, this.row);
      } else {
        this.body_visible = false
      }
    },
  },
}
</script>

<style lang="scss">
.my-card{
    .card-body{
        padding: 0;
    }
    &-header{
        &__left{
            display: flex;
        }
    }
}
</style>
